export const table_titles = [
	{ name: "Código", size: 7, order: "code" },
	{ name: "Cliente", size: 10, order: "customer_name" },
	{ name: "Producto", size: 20, order: "product_name" },
	{ name: "Cant. Envases", size: 5, order: "quantity" },
	{ name: "Contenido", size: 5, order: "container_content" },
	{ name: "Distribuidor", size: 8, order: "dealer_name" },
	{ name: "N° Factura", size: 7, order: "dealer_number" },
	{ name: "N° Envio", size: 7, order: "delivery_number" },
	{ name: "Estado", size: 5, order: "" },
	{ name: "Acción", size: 5, order: "" },
];

export const base_list = {
	page: 1,
	paginate: 10,
	order: "name",
	orderType: "desc",
	customer_id: "",
	status: "all",
};

export const base_element = {
	id: "",
	name: "",
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};
